
import { Vue } from "vue-class-component";

export default class LocationGray extends Vue {}
